import React from 'react';
import { Link } from 'react-router-dom';
import { PROCESS_STEPS, IMAGES } from '../mock';

const Process = () => {
  return (
    <div className="bg-black text-white">
      <section
        className="relative pt-40 pb-24"
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0.92), rgba(0,0,0,0.7)), url(${IMAGES.fabrication})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="font-display tracking-[0.3em] text-xs text-[#FF6B00] font-semibold mb-3">OUR PROCESS</div>
          <h1 className="font-display text-5xl md:text-7xl tracking-tight max-w-3xl">FROM CONCEPT TO CURBSIDE.</h1>
          <p className="text-neutral-300 max-w-xl mt-6">Every Fortune build follows a proven six-step process &mdash; dialed in over years of custom work.</p>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            {PROCESS_STEPS.map((s, i) => (
              <div key={s.n} className="relative p-8 border border-white/10 hover:border-[#FF6B00]/60 transition-colors group">
                <div className="flex items-start gap-6">
                  <div className="font-display text-5xl text-[#FF6B00] leading-none">{s.n}</div>
                  <div>
                    <h3 className="font-display text-2xl tracking-wide mb-3">{s.title.toUpperCase()}</h3>
                    <p className="text-neutral-400 leading-relaxed">{s.desc}</p>
                  </div>
                </div>
                {i < PROCESS_STEPS.length - 1 && (
                  <div className="absolute bottom-0 left-8 h-[2px] w-8 bg-[#FF6B00] hidden md:block" />
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-neutral-950 border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <h3 className="font-display text-2xl md:text-3xl tracking-tight">Ready to start the journey?</h3>
          <Link to="/contact" className="bg-[#FF6B00] hover:bg-[#E25500] transition-colors px-7 py-4 font-display tracking-[0.22em] text-sm font-bold">
            BOOK A CONSULTATION
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Process;
